module.exports = __webpack_public_path__ + "static/media/appetizer-bg.3b4c5d43.jpg";